import React from 'react';
import { Button, Box } from '@mui/material';
import { Language } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { t } = useTranslation();
  const { currentLanguage, switchLanguage } = useLanguage();

  const handleLanguageSwitch = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    switchLanguage(newLanguage);
  };

  return (
    <Button
      onClick={handleLanguageSwitch}
      startIcon={<Language />}
      sx={{
        color: "white",
        fontWeight: 600,
        px: 3,
        py: 1,
        borderRadius: 2,
        textTransform: 'none',
        fontSize: '0.95rem',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      {currentLanguage === 'en' ? 'عربي' : 'English'}
    </Button>
  );
};

export default LanguageSwitcher;
